var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg400({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 88V176.34H151.3V207.89H132.37V231.03H95.56V207.89H23V176.34L94.51 88H132.37ZM95.56 134.48L61.7 176.34H95.56V134.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392 243C378.114 243 365.795 239.769 355.044 233.307C344.443 226.695 336.081 217.228 329.959 204.906C323.986 192.433 321 177.631 321 160.5C321 143.369 323.986 128.642 329.959 116.32C336.081 103.847 344.443 94.3798 355.044 87.918C365.795 81.306 378.114 78 392 78C405.886 78 418.13 81.306 428.732 87.918C439.483 94.3798 447.844 103.847 453.817 116.32C459.939 128.642 463 143.369 463 160.5C463 177.631 459.939 192.433 453.817 204.906C447.844 217.228 439.483 226.695 428.732 233.307C418.13 239.769 405.886 243 392 243ZM392 200.398C403.945 200.398 409.918 187.098 409.918 160.5C409.918 133.902 403.945 120.602 392 120.602C380.055 120.602 374.082 133.902 374.082 160.5C374.082 187.098 380.055 200.398 392 200.398Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg400);
export default __webpack_public_path__ + "static/media/img_400.655100554c0c8ba00e9b28d302f499cf.svg";
export { ForwardRef as ReactComponent };